export const handleShowNavbarElements = ({
  screenWidth,
  setShowTP,
  setShowLock,
  setShowAutoSave,
  setShowExport,
  setShowMyScribeAi
}) => {
  if (screenWidth < 1350) {
    setShowTP(true);
  } else {
    setShowTP(false);
  }

  if (screenWidth < 1220) {
    setShowLock(true);
  } else {
    setShowLock(false);
  }

  if (screenWidth < 1089) {
    setShowAutoSave(true);
  } else {
    setShowAutoSave(false);
  }

  if (screenWidth < 970) {
    setShowExport(true);
  } else {
    setShowExport(false);
  }

  if (screenWidth < 747) {
    setShowMyScribeAi(true);
  } else {
    setShowMyScribeAi(false);
  }
};
